<form #shortCallsProfileDialog="ngForm" autocomplete="off">
  <!-- Name Field -->
  <mat-form-field class="fullWidth">
    <mat-label>Name</mat-label>
    <input matInput required [(ngModel)]="shortCallsProfile.name" maxlength="255" name="name">
    <mat-error>
      Name is <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <arm-form-title>Thresholds to Trigger Action</arm-form-title>


  <!-- Max Call Seconds -->
  <mat-form-field class="fullWidth">
    <mat-label>Short Call Duration Limit (in Seconds)</mat-label>
    <input
      matInput
      required
      type="number"
      min="1"
      [(ngModel)]="shortCallsProfile.durationInSec"
      name="maxCallSeconds">

    <mat-error>
      Maximum Short Call Duration <strong>required</strong>
    </mat-error>
  </mat-form-field>


  <!-- Minimum Calls per Day -->
  <mat-form-field class="fullWidth">
    <mat-label>Min. Calls per Day</mat-label>
    <input
      matInput
      required
      type="number"
      min="1"
      [(ngModel)]="shortCallsProfile.totalCalls"
      name="minCallsPerDay">



    <mat-error>
      Min. Calls per Day is <strong>required</strong>
    </mat-error>
  </mat-form-field>



  <!-- Percentage of Short Calls -->
  <mat-form-field class="fullWidth">
    <mat-label>Short Calls Percentage of Total Calls</mat-label>
    <input
      matInput
      required
      type="number"
      min="0"
      max="100"
      [(ngModel)]="shortCallsProfile.percentage"
      name="percentageThreshold">


    <mat-error>
      A valid Short Calls Percentage is <strong>required</strong>
    </mat-error>

  </mat-form-field>


  <div *ngIf="shortCallsProfile.id" class="warning"> <!-- if we dont have id its means this is edit mode (and not add) -->
    <span>
    Warning: Changing a threshold resets all current counters.
  </span>
  </div>
  <!-- Action checkbox -->
  <arm-form-title>Routing Action</arm-form-title>


  <!-- Toggle to enable/disable routing actions -->
  <mat-slide-toggle
    [(ngModel)]="enableRoutingAction"
    (change)="onRoutingToggleChange($event)"
    color="primary"
    name="isRoutingActionEnable"
  >
    Enable Routing Action
  </mat-slide-toggle>

  <mat-radio-group
    [(ngModel)]="routingAction"
    [disabled]="!enableRoutingAction"
    (change)="onRoutingActionChange($event)"
    [ngModelOptions]="{standalone: true}"
  >
    <mat-radio-button color="primary" value="LOCKED_FOR_OUTGOING">
      Lock peer connection for new outgoing calls
    </mat-radio-button>
    <mat-radio-button color="primary" value="DROP_OUTGOING">
      Drop new outgoing calls
    </mat-radio-button>
  </mat-radio-group>







</form>
